import { ReactNode } from "react";

interface Props {
    children: ReactNode
}

const WrapperEmpty = ({ children }: Props) => {

    return (
        <div className="mx-auto p-4 max-w-[360px] text-center">
            <div className="mb-6">{children}</div>
        </div>
    )
}

export default WrapperEmpty;